// extracted by mini-css-extract-plugin
export default {"root":"styles-root-bbc964","button":"styles-button-defc68","icon":"styles-icon-a3f0b8"};